<template lang="pug">
.options
    .backdrop
    .content
        .close(@click="cancel") ×
        NewTranslation(path="setPasswordDialog.title").title
        NewTranslation(path="setPasswordDialog.description").description
        .form
            .field
                label(for="field-password")
                    NewTranslation(path="setPasswordDialog.password.label")
                .field-input
                    font-awesome-icon(icon="fingerprint")
                    input(id="field-password" type="password" :placeholder="translate('setPasswordDialog.password.placeholder')" required)
            .field
                label(for="field-passwordrepeat")
                    NewTranslation(path="setPasswordDialog.passwordRepeat.label")
                .field-input
                    font-awesome-icon(icon="fingerprint")
                    input(id="field-passwordrepeat" type="password" :placeholder="translate('setPasswordDialog.passwordRepeat.placeholder').placeholder" required)
            Button(color="green" @click.native="success" path="setPasswordDialog.continue.button").button
                 font-awesome-icon(icon="chevron-right" slot="icon" style="padding-left: 2px")
</template>

<script>
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import i18next from 'i18next';

export default {
  components: {
    NewTranslation,
    Button,
  },
  props: ['overlaydata'],
  methods: {
    translate(path, params) {
      return i18next.t(path, params);
    },
    cancel() {
      if (this.overlaydata && this.overlaydata.cancel) this.overlaydata.cancel();
      this.$store.commit('openOverlay', '');
    },
    success() {
      if (this.overlaydata && this.overlaydata.success) this.overlaydata.success();
      this.$store.commit('openOverlay', '');
    },
  },
};
</script>

<style lang="sass" scoped>
.options
	width: 100%
	height: 100vh
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	position: fixed
	max-width: 480px
	margin: 0 auto
	right: 0
	top: 0
	left: 0
	z-index: 9
.backdrop
	background-color: rgba(0, 0, 0, .8)
	width: 100%
	height: 100vh
	position: absolute
	z-index: 6
.close
	position: absolute
	right: 20px
	top: 20px
	background-color: #fff
	z-index: 9
	color: #1DB2D1
	border: 1px solid #1DB2D1
	width: 20px
	height: 20px
	display: flex
	justify-content: center
	align-items: center
	border-radius: 20px
.content
	z-index: 7
	background-color: #fff
	border-radius: 10px
	padding: 20px
	margin: 20px
	position: relative
.title
	font-size: 20px
	color: #1DB2D1
	text-align: center
.description
	text-align: center
	color: #454F63
	margin-top: 20px
.form
	margin-top: 20px
	.field
		display: flex
		flex-direction: column
		& + .field
			margin-top: 20px
		input,
		select
			color: #454F63
			border-radius: 3px
			border: 1px solid #B3BAC8
			padding: 15px 15px 15px 45px
			margin-top: 5px
			background-color: #fff
			font-size: 1rem
			font-family: inherit
			width: 100%
		&-input
			position: relative
			svg
				position: absolute
				bottom: 0
				top: 5px
				left: 20px
				width: 15px
				margin-top: auto
				margin-bottom: auto
	.button
		margin-top: 20px
</style>
